import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {IonicModule} from '@ionic/angular';

import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {QsChecksControllingVeranstaltungPage} from './qs-checks-controlling-veranstaltung.page';
import {FormsModule} from '@angular/forms';
import {StoreModule} from '@ngrx/store';
import {reducers} from './qs-checks-controlling-veranstaltung.reducer';
import {RouterModule, Routes} from '@angular/router';
import {QsChecksControllingVeranstaltungPageUiEffects} from './qs-checks-controlling-veranstaltung.effects.ui';
import {QsChecksControllingVeranstaltungPageWsEffects} from './qs-checks-controlling-veranstaltung.effects.ws';
import {QschecksAufgabeBemerkungSetzenEffects, QschecksAufgabeKorrigierenEffects, QschecksPrueflaufControllingEffects, QschecksPrueflaufLoeschenEffects, QschecksVeranstaltungUebersichtEffects} from '../../../../client-ngrx/qschecks';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {PipesSharedModule} from '../../../shared/pipes/pipes-shared.module';

const routes: Routes = [
    {
        path: '',
        component: QsChecksControllingVeranstaltungPage,
        data: {title: 'QS Checks Controlling Veranstaltung'}
    }
];

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes),
        StoreModule.forFeature('QsChecksControllingVeranstaltungPage', reducers),
        EffectsModule.forFeature([
            QsChecksControllingVeranstaltungPageUiEffects,
            QsChecksControllingVeranstaltungPageWsEffects,

            QschecksVeranstaltungUebersichtEffects,
            QschecksPrueflaufControllingEffects,
            QschecksPrueflaufLoeschenEffects,
            QschecksAufgabeKorrigierenEffects,
            QschecksAufgabeBemerkungSetzenEffects
        ]),
        SopiScrollModule,
        FormsModule,
        SopiComponentsModule,
        PipesSharedModule,
    ],
    declarations: [QsChecksControllingVeranstaltungPage],
    entryComponents: [QsChecksControllingVeranstaltungPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QsChecksControllingVeranstaltungPageModule {
}
